<template>
	<div class="gb-photoalbum-list">
		<Loading v-if="loading" opacity="0.5"/>
		<GBPhotoAlbumHeader 
			v-bind:backURL="backURL"
		/>
		<div class="d-flex" style="z-index: 103;">
			<div class="gb-header-album-list">
				<div class="primary gb-header-album-layout">
					<v-layout align-center row fill-height pa-2>
						<v-flex class="d-flex" style="color: #fff;">
							<div class="name">{{ showAlbumHeaderName }}</div>
						</v-flex>
					</v-layout>
				</div>
			</div>
			<div class="gb-header-album" v-bind:style="styleHeader">
				<div class="primary gb-header-album-layout">
					<template v-if="!is_selecting_albums">
						<v-layout row v-if="selectedSchedule(params.schedule_id)">
							<v-btn flat large color="white" class="pa-0"
								v-on:click="onClickAddAlbum">
								<v-icon>add</v-icon>アルバムを追加する
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn v-if="!download_album" flat large color="white" class="pa-0" v-on:click="onClickDouwloadAll">すべてダウンロード</v-btn>
							<v-btn v-else flat large color="white" class="disabled" disabled>
								<v-progress-circular
									indeterminate
									color="white"
								></v-progress-circular>
							</v-btn>
							<v-btn flat large color="white" class="pa-0" v-on:click="onClickStartSelectingAlbums">選択</v-btn>
						</v-layout>
					</template>
					<template v-else>
						<v-layout row v-if="selectedSchedule(params.schedule_id)">
							<v-btn flat dark color="white" @click="onClickCancelSelectingAlbums">キャンセル</v-btn>
							<v-spacer />
							<v-layout style="align-items: center;">
								<v-flex>
									<h4 class="album-title" style="color: #FFFFFF;">選択中({{ selected_album.length }})</h4>
								</v-flex>
							</v-layout>
							<v-spacer />
							<v-btn flat dark color="white" @click="onClickSelectAllAlbums">{{ textSelectAll }}</v-btn>
						</v-layout>
					</template>
				</div>
			</div>
		</div>
		<div class="d-flex">
			<GBPhotoAlbumSelectList
				v-bind:items="listItems"
				v-bind:select_id="params.schedule_id"
				v-on:select-list="onClickSchedule"
			/>
			<div class="content-outer" v-bind:style="styleContent">
				<div class="content" v-bind:style="styleContentHeight">
					<v-layout class="pa-2" align-center column fill-height>
						<v-data-table
							v-if="selectedSchedule(params.schedule_id)"
							v-model="selected_album"
							:headers="table_headers"
							:items="list_album"
							item-key="id"
							:expand="false"
							:pagination.sync="pagination"
							hide-actions
							select-all
							class="elevation-1 photo-table"
							ref="album_list"
						>
							<template v-slot:headers="props">
								<tr>
									<th v-if="is_selecting_albums"><!--
										<v-checkbox
											:input-value="props.all"
											:indeterminate="props.indeterminate"
											primary
											hide-details
											@click.stop="onClickSelectAllAlbums"
										></v-checkbox>-->
									</th>
									<th 
										v-for="header in props.headers"
										:key="header.text"
										:align="header.value === 'setting' ? 'center' : 'left'"
									>
										{{ header.text }}
									</th>
									<th v-if="!is_selecting_albums" style="text-align: center;">設定</th>
								</tr>
							</template>
							<template v-slot:items="props">
								<tr @click="onClickAlbum(props)" class="data-table-body">
									<td
										v-bind:active="props.selected"
										v-if="is_selecting_albums"
									>
										<v-checkbox
											:input-value="props.selected"
											primary
											hide-details
										></v-checkbox>
									</td>
									<td class="name pa-0">
										<GBPhotoAlbumItemNotReference v-if="!props.item.reference" />
										<div class="px-4">
											{{ props.item.title }}
										</div>
									</td>
									<td>{{ props.item.insert_at }}</td>
									<td>{{ props.item.last_modified_at }}</td>
									<td>{{ props.item.items.length }}枚</td>
									<td
										class="justify-center layout px-0 cursor-pointer"
										@click.stop="onDisplayMenu(props)"
										v-if="!is_selecting_albums"
									>
										<v-icon small>menu</v-icon>
									</td>
								</tr>
							</template>
							<template v-slot:expand="props">
								<v-layout align-center justify-end row fill-height>
									<v-btn flat small color="red"
										@click="onDeleteAlbum(props)"
									>アルバムを削除</v-btn>
									<v-btn flat small color="primary"
										:disabled="download_album"
										@click="onDownloadAlbum(props)"
									>アルバムをダウンロード</v-btn>
								</v-layout>
							</template>
							<template v-slot:no-data>
								アルバムが登録されていません
							</template>
						</v-data-table>
					</v-layout>
				</div>
				<v-layout class="footer white" row outline v-if="is_selecting_albums">
					<v-flex xs6>
						<v-btn flat block dark color="#ff5252" @click="onDeleteSelectAlbums">削除</v-btn>
					</v-flex>
					<v-flex xs6>
						<v-btn flat block dark color="primary" @click="onDownloadSelectAlbums">ダウンロード</v-btn>
					</v-flex>
				</v-layout>
			</div>
		</div>
		<GBDialog
			:dialog="dialog" 
			@agree="onClickDialogAgree"
			@disagree="onClickDialogDisagree"
		/>
		<DialogConfirmDeletePhotoAlbum
			:display="dialog_del_album.display"
			@click-cancel="onClickCancelDeleteAlbum"
			@click-confirm="onClickConfirmDeleteAlbum"
		/>
	</div>
</template>
<script>
import Notification from '../../classes/Notification';
import APIClient from '../../classes/APIClient';
import Loading from '../Loading';
import GBPhotoAlbumHeader from './GBPhotoAlbumHeader';
import GBPhotoAlbumSelectList from './GBPhotoAlbumSelectList';
import GBPhotoAlbumItemNotReference from './GBPhotoAlbumItemNotReference';
import GBDialog from '../GBDialog';
import DialogConfirmDeletePhotoAlbum from './DialogConfirmDeletePhotoAlbum';
import {ARCHIVE_TYPE, GANTTBOARD_EVENT_ID, DATETIME_FORMAT} from '../../data/Const';
import ConoHa from '../../classes/ConoHa';
import Util from '../../classes/Util';
import clonedeep from 'lodash/cloneDeep';

const chunkSplitPromiseAll = async (items, callback) => {
	let i, j, k, chunk_size = 5;

	for (i=0,j=items.length; i<j; i+=chunk_size) {
		let chunk = [];
		for (k=i; k < i + chunk_size; k++) {
			if (items[k] !== undefined)
				chunk.push(items[k]);
		}
		await Promise.all(chunk.map(callback));
	}
};

const strftime = require('strftime');

const HEADER_HEIGHT = 30;
const HEADER_ALBUM_HEIGHT = 59;

export default {
	name: "GBPhotoAlbumList",
	data() {
		return {
			api: null,
			conoha: null,
			params: {
				contractor_id: null,
				parent_name: null,
				parent_id: null,
				schedule_id: null,
				fetch: null,
			},
			list_schedule: [],
			list_album: [],
			loading: false,
			project: null,
			member: null,
			schedule: null,
			is_selecting_albums: false,
			table_headers: [
				{ text: 'タイトル', value: 'title' },
				{ text: '作成日時', value: 'create_at' },
				{ text: '更新日時', value: 'update_at' },
				{ text: '枚数', value: 'number_of_photos' },
			],
			pagination: {
				sortBy: 'update_at',
				rowsPerPage: -1,
			},
			selected_album: [],
			delete_albums: [],
			dialog: {
				display: false,
				title: null,
				text: null,
				disagree: null,
				agree: null,
			},
			dialog_del_album: { display: false },
			download_album: false,
			expanded_id: null,
		};
	},
	components: {
		Loading,
		GBPhotoAlbumHeader,
		GBPhotoAlbumSelectList,
		GBPhotoAlbumItemNotReference,
		GBDialog,
		DialogConfirmDeletePhotoAlbum,
	},
	methods: {
		initData: async function (route) {
			let contractor_id = route.params.contractor_id;
			let schedule_id = route.hash.replace('#', '');
			this.loading = true;

			try {
				this.params.contractor_id = contractor_id;
				this.params.schedule_id = schedule_id;
				if (route.params.project_id) {
					this.params.parent_name = 'project';
					this.params.parent_id = route.params.project_id;
					this.params.fetch = () => {
						return this.fetch_schedule_list(contractor_id, {
							project_id: this.params.parent_id,
						});
					};
				} else if (route.params.member_id) {
					this.params.parent_name = 'member';
					this.params.parent_id = route.params.member_id;
					this.params.fetch = () => {
						return this.fetch_schedule_list(contractor_id, {
							member_id: this.params.parent_id,
						});
					};
				} else {
					throw new Error('Invalid URL');
				}

				await this.params.fetch();

				let schedule = this.selectedSchedule(schedule_id);
				if (schedule) {
					await this.fetch_album_list(contractor_id, schedule);
				} else {
					this.error('案件、もしくはスケジュールが削除されました');
					this.onClickCancelSelectingAlbums();
				}
			} catch {
				this.error('初期化に失敗しました');
			} finally {
				this.loading = false;
			}
		},
		onUpdateDataSet: function() {
			this.initData(this.$route);
		},
		onUpdatePhotoAlbum: function(data) {
			if (!this.params.schedule_id || (this.params.schedule_id != data.schedule_id))
				return;

			this.$store.dispatch('addNotification', Notification.info('アルバムを同期しました'));
			this.initData(this.$route);
		},
		onDownloadPhotoAlbum: function() {
			this.download_album = false;
		},
		onClickBack: function() {
			let url = [
				this.$route.params.contractor_id, 'photoalbum',
				this.params.parent_name,
			];
			this.$router.push('/' + url.join('/') + '/#' + this.params.parent_id);
		},
		onClickSchedule: function(schedule_id) {
			let url =  this.$route.path + '#' + schedule_id;
			this.$router.push(url);
		},
		onClickAlbum: function(props) {
			if (this.is_selecting_albums){
				props.selected = !props.selected;
			} else {
				let url = [
					this.$route.params.contractor_id, 'photoalbum', 
					this.params.parent_name, this.params.parent_id,
					'schedule', this.params.schedule_id, 'album',
				];
				this.$router.push('/' + url.join('/') + '/#' + props.item.id);
			}
		},
		onClickAddAlbum: function() {
			let uri_params = [
				this.params.contractor_id,
				'photoalbum',
				this.params.parent_name,
				this.params.parent_id,
				'schedule',
				this.params.schedule_id,
				'create',
			];
			this.$router.push('/' + uri_params.join('/'));
		},
		logout: function() {
			this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
			this.$store.dispatch('logout');
			this.$router.push({name: 'Login', params: { 'contractor_id': this.$route.params.contractor_id }});
		},
		fetch_schedule_list: function(contractor_id, cond) {
			return this.api.getPhotoAlbumScheduleList(cond)
				.then((res) => {
					this.list_schedule = res.data;
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					throw e;
				});
		},
		fetch_album_list: function(contractor_id, schedule) {
			return this.api.getPhotoAlbumListOfSchedule(schedule.schedule_id)
				.then((res) => {
					this.project = res.data.project;
					this.member = res.data.member;
					this.schedule = res.data.schedule;
					this.list_album = res.data.album_list;
					this.list_album.forEach(a => {
						if (a.last_modified_at) {
							let m_utc = Util.getUTCFromYMDHMS(a.last_modified_at);
							a.last_modified_at = strftime(DATETIME_FORMAT, new Date(m_utc));
						}
						let i_utc = Util.getUTCFromYMDHMS(a.insert_at);
						a.insert_at = strftime(DATETIME_FORMAT, new Date(i_utc));
					});
				})
				.catch((e) => {
					if (e.token) {
						this.logout();
						return;
					}
					throw e;
				});
		},
		error: function(text) {
			this.$store.dispatch('addNotification', Notification.error(text));
		},
		downloadAllAlbum: function() {
			this.download_album = true;
			let socketio_id = this.$store.getters.socketioID;
			this.api.downloadArchive(
					this.project.id,
					this.member.id,
					this.schedule.id,
					null,
					socketio_id,
					null,
					ARCHIVE_TYPE.SCHEDULE_ALL,
				)
				.catch(() => {
					this.download_album = false;
					this.$store.dispatch('addNotification', Notification.error('ダウンロードに失敗しました'));
				});
		},
		downloadSelectedAlbum: function(album_id) {
			this.download_album = true;
			let socketio_id = this.$store.getters.socketioID;
			this.api.downloadArchive(
					this.project.id,
					this.member.id,
					this.schedule.id,
					album_id,
					socketio_id,
					null,
					ARCHIVE_TYPE.SCHEDULE_SELECTED,
				)
				.catch(() => {
					this.download_album = false;
					this.$store.dispatch('addNotification', Notification.error('ダウンロードに失敗しました'));
				});
		},
		downloadAlbum: function(album_id) {
			this.download_album = true;
			let socketio_id = this.$store.getters.socketioID;
			this.api.downloadArchive(
					this.project.id,
					this.member.id,
					this.schedule.id,
					album_id,
					socketio_id,
					null,
					ARCHIVE_TYPE.ALBUM_ALL,
				)
				.catch(() => {
					this.download_album = false;
					this.$store.dispatch('addNotification', Notification.error('ダウンロードに失敗しました'));
				});
		},
		onClickDouwloadAll: function() {
			this.downloadAllAlbum();
		},
		onDownloadSelectAlbums: function() {
			if (this.selected_album.length === 0) {
				this.errorDialog('アルバムを選択してください');
				return;
			}
			let select_album_id = this.selected_album.map(a => a.id);
			this.downloadSelectedAlbum(select_album_id);
			this.onClickCancelSelectingAlbums();
		},
		onDeleteSelectAlbums: function() {
			if (this.selected_album.length === 0) {
				this.errorDialog('アルバムを選択してください');
				return;
			}
			this.selected_album.forEach(a => {
				this.delete_albums.push(a);
			});
			this.dialog_del_album.display = true;
		},
		onClickStartSelectingAlbums: function() {
			this.is_selecting_albums = true;
			if (this.expanded_id)
				this.$refs.album_list.expanded[this.expanded_id] = false;
		},
		onClickCancelSelectingAlbums: function() {
			this.selected_album = [];
			this.is_selecting_albums = false;
		},
		onClickSelectAllAlbums: function() {
			if (this.selected_album.length)
				this.selected_album = [];
			else
				this.selected_album = this.list_album.slice();
		},
		onDisplayMenu: function(props) {
			props.expanded = !props.expanded;
			this.expanded_id = props.item.id;
		},
		onDownloadAlbum: function(props) {
			props.expanded = !props.expanded;
			this.downloadAlbum(props.item.id);
		},
		onDeleteAlbum: function(props) {
			props.expanded = !props.expanded;
			this.delete_albums.push(props.item);
			this.dialog_del_album.display = true;
		},
		deleteFromConoHa: async function(items) {
			await chunkSplitPromiseAll(items, async (item) => {
				/* サムネイルは残す */
				// await this.conoha.deleteByURI(item.thumbnail_uri);
				await this.conoha.deleteByURI(item.photo_uri);
			});
		},
		onClickDialogDisagree: function() {
			if (this.dialog.disagree)
				this.dialog.disagree();
			return;
		},
		onClickDialogAgree: function() {
			if (this.dialog.agree)
				this.dialog.agree();
			return;
		},
		onClickCancelDeleteAlbum: function() {
			this.delete_albums = [];
			this.dialog_del_album.display = false;
		},
		onClickConfirmDeleteAlbum: function() {
			this.dialog_del_album.display = false;
			this.loading = true;

			this.delete_albums.forEach((da, index) => {
				this.api.deletePhotoAlbum(da.id)
					.then(async () => {
						await this.deleteFromConoHa(da.items);
						this.list_album = this.list_album.filter(a => a.id !== da.id);
					})
					.catch((e) => {
						if (e.token) {
							this.$store.dispatch('addNotification', Notification.error('もう一度ログインしてください'));
							this.logout();
							return;
						}
						this.error('削除に失敗しました');
					})
					.then(() => {
						if (index === this.delete_albums.length - 1) {
							this.loading = false;
							this.delete_albums = [];
							this.onClickCancelSelectingAlbums();
						}
					});
			});
		},
		errorDialog: function(text) {
			this.dialog.title = 'エラー';
			this.dialog.text = text;
			this.dialog.disagree = null;
			this.dialog.agree = () => {
				this.dialog.display = false;
				this.dialog.agree = null;
			};
			this.dialog.display = true;
		},
		onWindowResize: function() {
			Util.onWindowResize(() => {
				this.$store.dispatch('setWindowSize', {
					width: window.innerWidth,
					height: window.innerHeight,
				});
			});
		},
		selectedSchedule: function(schedule_id) {
			let schedule = this.list_schedule.filter(s => s.schedule_id === schedule_id)[0];
			return schedule;
		},
	},
	computed: {
		backURL: function() {
			let url = [
				this.$route.params.contractor_id, 'photoalbum',
				this.params.parent_name,
			];
			return '/' + url.join('/') + '/#' + this.params.parent_id;
		},
		showAlbumHeaderName: function() {
			if (!this.params.parent_name)
				return '';
			if (!this.project && !this.member)
				return '';
			
			if (this.params.parent_name === 'project')
				return this.project.name;
			else if (this.params.parent_name === 'member')
				return this.member.name;
			
			return '';
		},
		styleHeader: function() {
			let left = this.$store.getters.boardLeftPosition;
			let width = this.$store.getters.width - 317;
			
			return {
				width: width + 'px',
				left: left + 'px',
			};
		},
		styleContent: function() {
			return {
				'max-width': (this.$store.getters.width - this.$store.getters.listWidth) + 'px',
				'height': (this.$store.getters.height - HEADER_HEIGHT - HEADER_ALBUM_HEIGHT) + 'px',
			}
		},
		listItems: function() {
			return clonedeep(this.list_schedule).map(item => {
				return {
					'id': item.schedule_id,
					'name': item.name,
					'reference': item.reference,
					'title': item.schedule_title,
					'schedule': this.textSchedule(item.schedule_begin, item.schedule_end),
				};
			});
		},
		textSchedule: function() {
			return function(begin, end){
				return begin.slice(0,4) + '年' + begin.slice(4,6) + '月' + begin.slice(6,8) + '日 ～ ' + end.slice(0,4) + '年' + end.slice(4,6) + '月' + end.slice(6,8) + '日';
			};
		},
		textSelectAll: function() {
			if (this.selected_album.length)
				return 'すべて解除';
			else
				return 'すべて選択';
		},
		styleContentHeight: function() {
			let height = this.$store.getters.height - HEADER_HEIGHT - HEADER_ALBUM_HEIGHT;
			if (this.is_selecting_albums)
				height -= 50;
			return {height: height + 'px'};
		},
	},
	mounted: function() {
		this.api = new APIClient(this.$store);
		this.conoha = new ConoHa(this.$store.getters.datasetManager);
		this.initData(this.$route);
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.PHOTOALBUM_UPDATE,
			listener: this.onUpdatePhotoAlbum,
		});
		this.$store.commit('addGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.ALBUM_DOWNLOAD,
			listener: this.onDownloadPhotoAlbum,
		});
	},
	created: function() {
		window.addEventListener('resize', this.onWindowResize, false);
		this.onWindowResize();
	},
	beforeDestroy: function() {
		window.removeEventListener('resize', this.onWindowResize);
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.DATASET_UPDATE,
			listener: this.onUpdateDataSet,
		});
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.PHOTOALBUM_UPDATE,
			listener: this.onUpdatePhotoAlbum,
		});
		this.$store.commit('removeGanttBoardEventListener', {
			type: GANTTBOARD_EVENT_ID.ALBUM_DOWNLOAD,
			listener: this.onDownloadPhotoAlbum,
		});
	},
	beforeRouteUpdate(to, from, next) {
		this.initData(to)
			.then(() => {
				next();
			});
	},
};
</script>
<style>
.gb-photoalbum-list {
	background-color: #fefefe;
}
.gb-photoalbum-list .gb-header-album-list {
	flex: 0 0 300px !important;
	position: relative;
	border:solid 1px #DFDFDF;
	height: 59px;
	width: 300px;
	border-left: none;
}
.gb-photoalbum-list .gb-header-album-layout {
	position: relative;
	display: flex;
	align-items: center;
	padding: 0px 19px 0px 0px;
	height: 57px;
}
.gb-photoalbum-list .gb-header-album-layout .name {
	word-wrap: normal;
	overflow: hidden;
	height: 1.5rem;
}
.gb-photoalbum-list .gb-header-album {
	position: relative;
	border:solid 1px #DFDFDF;
	height: 59px;
	border-left: none;
}
.gb-photoalbum-list .content-outer {
	position: relative;
	z-index: 101;
	overflow-y: hidden;
	overflow-x: hidden;
}
.gb-photoalbum-list .content-outer .content {
	position: relative;
	border:solid 1px #DFDFDF;
	overflow-y: scroll;
	overflow-x: hidden;
	width: 100%;
	height: 100%;
	-webkit-overflow-scrolling: touch;
	overscroll-behavior-y: contain;
}
.gb-photoalbum-list .content-outer .footer {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 50px;
	box-shadow: -10px 10px 10px 10px rgba(0,0,0,0.4);
}
.gb-photoalbum-list .photo-table {
	width: 100%;
}
.data-table-body {
	user-select: none !important;
}
.cursor-pointer {
	cursor: pointer;
}
</style>
